// Module
var code = "<p>Create a simple invoice then send it to your customer by email and text message. Start from scratch or turn an existing quote into an invoice.<br/><br/>For more complex invoices or to add photos, use Projects.</p>\n";
// Exports
module.exports = code;